(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealTargets = document.querySelectorAll('.section, .page-hero, .product-card, .media-frame, .step, .faq-item, .upsell-panel, .review-placeholder, .password-panel');

  revealTargets.forEach(function (node, index) {
    node.classList.add('motion-ready');
    node.style.setProperty('--reveal-delay', Math.min(index * 40, 360) + 'ms');
  });

  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealTargets.forEach(function (node) { node.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

  revealTargets.forEach(function (node) { observer.observe(node); });

  window.addEventListener('scroll', function () {
    document.documentElement.style.setProperty('--scroll-y', String(window.scrollY || 0));
  }, { passive: true });
})();
